export function trackUpsellCta({tracking, product, ctaAction = UPSELL_CTA_ACTIONS.addToCart}) {
  if (!tracking?.type || !tracking?.context || !product) return;

  const priceCents = product.promotionPrice ?? product.price_cents;
  const price = Number(priceCents || 0) / 100;

  useGtm().trackEvent({
    event: 'core_ui-upsell_cta-click',
    action: 'click',
    category: 'upsell',
    upsell_type: tracking.type,
    upsell_context: tracking.context,
    cta_action: ctaAction,
    value: price,
    currency: 'USD',
    items: [{
      item_id: product.sku,
      item_name: product.name || product.label,
      item_list_name: 'Upsell',
      item_list_id: 'upsell',
      item_category: tracking.type,
      price,
      quantity: 1
    }]
  });
}
